export default {
    'confirm-modification': 'Confirm modification',
    'are-you-sure-you-want-to-save-the-modifications?': 'Are you sure you want to save the modifications?'
};
